export const getCreditNoteStatusDatePrefix = (status: string) => {
  if (status === "refund_due") {
    return "since";
  }
  return "on";
};
